import React from "react";
import { useParams, Link } from "react-router-dom";
import {
  ChevronRight,
  ChevronLeft,
  Zap,
  Power,
  Wrench,
  Gauge,
  Plug2,
  BatteryCharging,
  SunMedium,
} from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import { allTerms } from "../data/terms";
import SEO from "../components/SEO";

const iconMap = {
  "Groepenkast vervangen": Zap,
  "Kookgroep aansluiten": Power,
  "Elektra renovatie": Wrench,
  "3 Fase aansluiting": Gauge,
  "Elektra aanleggen": Plug2,
  Laadpaal: BatteryCharging,
  Zonnepanelen: SunMedium,
};

function Term() {
  const { slug } = useParams();
  const term = allTerms.find((t) => t.slug === slug);

  if (!term) {
    return (
      <div className="min-h-screen bg-white page-transition mt-[99px] md:mt-[133px] pt-6">
        <SEO
          title="Term niet gevonden - elektricieninarnhem026.nl"
          description="We hebben de term die je zoekt niet gevonden."
          image="/images/banner.png"
        />
        <Header />
        <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
          <h1 className="font-bold text-black leading-[1.25] text-[40px] lg:text-[52px] mb-8 text-[28px] md:mb-10 md:text-[44px] text-[#17354A]">
            Term niet gevonden
          </h1>
          <Link to="/begrippen" className="text-[#F47B20] hover:underline">
            Terug naar begrippenlijst
          </Link>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white page-transition mt-[99px] md:mt-[133px] pt-6">
      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <div className="mb-12">
          <Link
            to="/begrippen"
            className="inline-flex items-center text-[#F47B20] hover:underline"
          >
            <ChevronLeft className="w-5 h-5 mr-1" />
            Terug naar begrippenlijst
          </Link>
        </div>

        <h1 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
          {term.term}
        </h1>

        <div className="grid grid-cols-1 gap-12">
          <div>
            <p className="text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
              {term.definition}
            </p>
            {term.extendedDescription && (
              <div className="text-[16px] md:text-[18px] font-normal text-[#17354A] mb-8">
                {term.extendedDescription}
              </div>
            )}
            <div className="mb-12">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                  <ChevronRight className="w-4 h-4" />
                </span>
              </Link>
            </div>
          </div>

          {term.relatedTerms && term.relatedTerms.length > 0 && (
            <div>
              <h2 className="font-bold text-[24px] lg:text-[36px] text-[#17354A] mb-6">
                Gerelateerde onderwerpen
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {term.relatedTerms.map((relatedTerm, index) => {
                  const IconComponent = iconMap[relatedTerm.term] || Wrench;
                  return (
                    <Link
                      key={index}
                      to={`/begrippen/${relatedTerm.slug}`}
                      className="flex items-center p-6 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                    >
                      <span className="text-[#17354A] text-lg font-medium">
                        {relatedTerm.term}
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Term;
